/*
 * @Author       : wangyanan
 * @Date         : 2025-01-13 16:25:00
 * @LastEditTime : 2025-01-13 16:35:29
 * @LastEditors  : wangyanan
 */
/**
 * @author [zhaowenjie08]
 * @email [zhaowenjie08@58.com]
 * @create date 2021-08-12 17:00:41
 * @modify date 2022-12-26 10:36:22
 * @desc [项目配置]
 */

export const excludeAssetWhiteList: string[] = ['//s.anjuke.com/', '//webapi.amap.com/', '//api.map.baidu.com']

interface SubAppProps {
  name: string;
  activeRule: string;
  entry: string;
}

export const getSubAppConfig = (loader: unknown): Record<string, any>[] => {
  const hostname = window.location.hostname
  const pathname = window.location.pathname

  const subappConfig: SubAppProps[] = [
    // 默认子应用 @huajie01
    { name: 'subapp-main', activeRule: '/webapp/main', entry: `//${hostname}/subapp/main` },
    // 全核验业务线子应用 @zhaowenjie08
    { name: 'subapp-qhy', activeRule: '/webapp/qhy', entry: `//${hostname}/subapp/qhy` },
    // 商业地产墨斗子应用 @weijie03
    { name: 'subapp-sydc_model', activeRule: '/webapp/sydc_model', entry: `//${hostname}/subapp/sydc_model` },
    // 商业地产 @baidongying
    { name: 'subapp-sydc', activeRule: '/webapp/sydc', entry: `//${hostname}/subapp/sydc` },
    // vr业务线子应用 @wanghao
    { name: 'subapp-vr', activeRule: '/webapp/vr', entry: `//${hostname}/subapp/vr` },
    // 业主子应用 @zhuqiuzhi
    { name: 'subapp-yezhu', activeRule: '/webapp/yezhu', entry: `//${hostname}/subapp/yezhu` },
    // panshi @zhaowenjie08
    { name: 'subapp-bizdata', activeRule: '/webapp/bizdata', entry: `//${hostname}/subapp/bizdata` },
    // 趣探房后台 @zhaowenjie08
    { name: 'subapp-qtf', activeRule: '/webapp/qtf', entry: `//${hostname}/subapp/qtf` },
    // 实勘业务线子应用 @wanghao
    { name: 'subapp-shikan', activeRule: '/webapp/shikan', entry: `//${hostname}/subapp/shikan` }
  ]

  return subappConfig.map((item: SubAppProps) => {
    let pathSuffix = ''
    if (location.pathname.indexOf(item.activeRule + '/') === 0) {
      // 为了子应用能统计到自己的url访问量
      pathSuffix = pathname.replace(item.activeRule + '/', '/')
    }
    const config: Record<string, any> = {
      name: item.name,
      entry: item.entry + pathSuffix,
      container: '#subapp-viewport',
      loader,
      activeRule: item.activeRule
    }
    return config
  })
}
